
// eslint-disable-next-line @typescript-eslint/no-unused-vars

import { Component, Vue } from "vue-property-decorator";
import NRProjectEdit from "../components/nr-project-edit.vue";
import NRAttachmentEdit from "../components/nr-attachment-edit.vue";
import { NRClientType } from "@/lib/model/NRXQ/nr";
import { NRCandidate } from "@/lib/model/NRXQ/candidate";

@Component({
  components: {
    NRProjectEdit,
    NRAttachmentEdit
  }
})
export default class HomeNr extends Vue {
  atsCvOutId = "";
  type!: string; // 0 = 过往履历 ； 1 = 案例文件
  clientType = NRClientType.NRClientTypeCandidate;
  cv: NRCandidate | null = null;
  isSaved = false;

  beforeUnloadHandler(e: any) {
    if (this.type == "0" && !this.isSaved) {
      e.returnValue = "编辑内容尚未保存，是否离开此页面？"; // 此处返回任意字符串，不返回null即可，不能修改默认提示内容
    }
  }

  onSave() {
    this.isSaved = true;
    console.log("saved");
  }

  async created() {
    const params = this.$route.query;
    this.type = (params?.type as string) || "0";
    this.atsCvOutId = (params?.id as string) || "";

    if (this.atsCvOutId) {
      this.cv = await NRCandidate.get(this.atsCvOutId, this.clientType);
      if (this.cv) {
        if (
          (this.type == "0" && this.cv.canUpdateNrProject !== 1) ||
          (this.type == "1" && this.cv.canUpdateNrAttachment !== 1)
        ) {
          this.$message.error(
            "当前链接已暂时被关闭，如需更新信息请与对接人联系"
          );
          this.cv = null;
        }
      }
    } else {
      this.$message.error("当前链接错误，请与对接人联系");
    }
  }
  mounted() {
    window.addEventListener("beforeunload", this.beforeUnloadHandler, false);
  }
  destroyed() {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler, false);
  }
}
